import { Icon, IconProps } from "../";

export const DroprightIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2716 16.6549C9.80455 16.4614 9.5 16.0056 9.5 15.5V8.50004C9.5 7.99446 9.80455 7.53866 10.2716 7.34519C10.7387 7.15171 11.2764 7.25866 11.6339 7.61615L15.1339 11.1162C15.622 11.6043 15.622 12.3958 15.1339 12.8839L11.6339 16.3839C11.2764 16.7414 10.7387 16.8484 10.2716 16.6549Z"
      />
    </Icon>
  );
};
